/**
 * API 응답 값으로 전달 된 최근 본 상품 목록을 저장한다.
 * @param {*} state 
 * @param {Array} recentList - 최근 본 상품 목록
 */
const SET_RECENT_PRODUCT_LIST = (state, recentList) => {
  state.recentList = recentList
}
/**
 * 최근 본 상품 목록 중에서 특정 상품을 제거한다.
 * @param {*} state 
 * @param {Number} productId - 상품 id
 */
const REMOVE_RECENT_PRODUCT = (state, productId) => {
  state.recentList = state.recentList.filter(el=>el.productId != productId)
} 
export default {
  SET_RECENT_PRODUCT_LIST,
  REMOVE_RECENT_PRODUCT
}
